class ServiceResponse {
  constructor({ success, message, data, error }) {
    this.success = success === undefined ? !!data : !!success;
    this.message = message || '';
    this.data = data;
    this.error = error;
  }
}

module.exports = ServiceResponse;
